<img src="./assets/images/check-gr.png" alt="" class="img-responsive centered-image mb-2">
<h4 mat-dialog-title>You've been succesfully verified, please login.</h4>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
